import { useEffect, useState } from 'react';

/**
 * useState remembered in this browser's localStorage, for per-viewer conveniences (e.g. a collapsed sidebar). Falls
 * back to plain state when storage is blocked.
 */
export default function useStoredState(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const stored = window.localStorage.getItem(key);
      return stored === null ? initial : JSON.parse(stored);
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // storage blocked: the choice lasts until reload
    }
  }, [key, value]);

  return [value, setValue];
}
